import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {updateUserArticlesManager} from '../../../redux/actions/userActions';

class StaffLists extends Component {
    deactiveShopManager = () => {
        const userId = this.props.user.userId;
        this.props.updateUserArticlesManager(userId);
    }
    render() {
        const {user, permistions: {loading}} = this.props;
        return (
            <div className="box-staff shop-manager">
                <div className="avatar" style={{backgroundImage: `url(${user.imageUrl ? user.imageUrl : '/images/no-image.jpg'})`}} />
                <div className="content">
                    <p className="name">{user.fullname}</p>
                    <p className="email">{user.email ? user.email : 'Không xác định'}</p>
                    <p className="phone">{user.phone ? user.phone : 'Không xác định'}</p>
                    <p className="gender">{user.gender === 1 ? 'Nữ' : user.gender === 2 ? 'Khác' : 'Nam'}</p>
                    <div className="alignCenter">
                        <button className="btn btn-action" onClick={this.deactiveShopManager} disabled={loading}>{loading ? 'Đang tải...' : 'Trục xuất'}</button>
                    </div>
                </div>
            </div>
        )
    }
}

StaffLists.propTypes = {
    updateUserArticlesManager: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    permistions: state.permistions,
})

export default connect(mapStateToProps, { updateUserArticlesManager })(StaffLists);
